import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiBody, ApiProperty, ApiTags } from "@nestjs/swagger";

import { StockItemCategoryService } from "./stock-item-category.service";
import { StockItemCategoryDTO } from "./stock-item-category.dto";
import { StockItemCategoryResponseModel } from "libs/shared-models/masters/src/lib/stock-item-category";

@ApiTags('stock-item-categories')
@Controller('stock-item-categories')
export class StockItemCategoryController {
    constructor(
        private service: StockItemCategoryService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler) {
    }



    @Post('/StockItemCategoryService')
    @ApiBody({type:StockItemCategoryDTO})
    async StockItemuploadExcel(@Body() data:any): Promise<StockItemCategoryResponseModel>{
       try{
        return this.service.StockItemuploadExcel(data);
       } catch(err){
        return this.applicationExceptionHandler.returnException(StockItemCategoryResponseModel,err);
       }
    }


    @Post('/getStockItem')
    async getStockItem(): Promise<StockItemCategoryResponseModel> {
        try {
            return this.service.getStockItem();
        } catch (err) {
            return this.applicationExceptionHandler.returnException(StockItemCategoryResponseModel, err);

        }
    }

    @Post('/getVendorCategories')
    async getVendorCategories(): Promise<StockItemCategoryResponseModel> {
      try {
        return await this.service.getVendorCategories();
      } catch (err) {
        // Assuming you have an exception handler in your service
        return this.applicationExceptionHandler.returnException(StockItemCategoryResponseModel, err);
      }
    }

    @Post('/getEndCustomerCategories')
    async getEndCustomerCategories(): Promise<StockItemCategoryResponseModel> {
      try {
        return await this.service.getEndCustomerCategories();
      } catch (err) {
        // Assuming you have an exception handler in your service
        return this.applicationExceptionHandler.returnException(StockItemCategoryResponseModel, err);
      }
    }

    @Post('/getStockItemCategories')
    async getStockItemCategories(): Promise<StockItemCategoryResponseModel> {
      try {
        return await this.service.getStockItemCategories();
      } catch (err) {
        // Assuming you have an exception handler in your service
        return this.applicationExceptionHandler.returnException(StockItemCategoryResponseModel, err);
      }
    }


}